import { useSelector } from '../actions/types';
import { getCurrentPage } from '../selectors/page';
/**
 * A hook to return information about the current page.
 */
export function usePageInfo() {
    return useSelector(getCurrentPage);
}
//# sourceMappingURL=usePageInfo.js.map